import { Post, ShopifyCartActions, GetUrlParams } from './nyb-utils.js';

const getRandomNumber = () => {
    return Math.floor(Math.random() * 1000) + 1;
};

class LinkedProducts {
    constructor(wrapper,settings) {
        this.wrapper = wrapper;
        this.settings = settings;
        this.elements = this.getRequiredElements();
        this.attachEvents();
        this.selectedSize = this.settings.defaultSelection;
        this.deliverySelect = undefined;
        this.sellingPlan = undefined;
        this.checkUrlParams();
        this.uniqueId = new Date().getTime().toString();
        this.customProperties = {};
    };

    getRequiredElements = () => {
        return {
            form: document.querySelector('form[action="/cart/add"]'),
            purchaseRadios: document.querySelectorAll('[name="purchase-type"]'),
            sizeSelect: document.getElementById('linked-product-selector'),
            descriptions: document.querySelectorAll('.LinkedProduct__Description .prose'),
            deliverySelects: document.querySelectorAll('select[name="selling-plan-delivery"]'),
            labels: {
                regular: document.querySelector('label[for="regular"] span'),
                subscription: document.querySelector('label[for="subscription"] span'),
            },
            quantity: document.querySelector('input[name="quantity"]'),
            addToCart: document.querySelector('input.add-to-cart'),
            productPrice: {
                default: document.querySelector('.price-list--product span.price span.money'),
                original: document.querySelector('.price-list--product span.price span.money')
            },
            deliverySelectWrapper: {
                query: '.LinkedProduct__Delivery'
            },
            tab: document.querySelector('div[data-et-handle="tabs-info"] .easytabs-content-holder.prose')
        }
    };

    attachEvents = () => {
        this.elements.form.addEventListener('submit', this.handleAddToCart);
        this.elements.sizeSelect.addEventListener('change', this.handleSizeChange);
        this.elements.addToCart.addEventListener('click', this.handleAddToCart);
        this.elements.purchaseRadios.forEach(radio => {
            radio.addEventListener('change', this.handlePurchaseChange);
        });
        this.elements.deliverySelects.forEach(select => {
            select.addEventListener('change', this.handleSubscriptionChange);
        });
    };

    handleSizeChange = event => {
        this.selectedSize = {
            product: event.target.value.split('-')[0],
            variant: event.target.value.split('-')[1]
        };
        this.updatePrice();
        this.updateDescription(this.selectedSize.product);
    };

    handlePurchaseChange = (event) => {
        switch(event.target.value) {
            case 'one-time':
                this.sellingPlan = undefined;
                // Hide all elements
                document.querySelectorAll(this.elements.deliverySelectWrapper.query).forEach(element => {
                    element.dataset.nybShow = false;
                });
                break;
            case 'subscription':
                // Display delivery selector
                document.querySelectorAll(this.elements.deliverySelectWrapper.query).forEach(element => {
                    if(Number(element.dataset.nybTarget) === Number(this.selectedSize.product)) {
                        element.dataset.nybShow = true;
                        this.sellingPlan = element.querySelector('select').value;
                    }
                });
                break;
        };
    };

    handleAddToCart = (event) => {
        this.addToCart();
        event.preventDefault();
    };

    handleSubscriptionChange = (event) => {
        this.sellingPlan = event.target.value;
    };

    addFixedFlavors = () => {
        
        const flavors = document.querySelectorAll(`div[data-product-curated-flavors="${this.selectedSize.product}"] input[type="hidden"][data-product-property]`);

        if (!flavors) {
            return false;
        }

        this.customProperties = {};
        flavors.forEach(input => {
            this.customProperties[input.dataset.productProperty] = input.value;
        });
    }

    addToCart = async () => {
        
        if(this.selectedSize.variant === '') {
            return false
        };

        // pull flavors for curated boxes
        this.addFixedFlavors();

        await Post(ShopifyCartActions.add, {
            items: [{
                id: Number(this.selectedSize.variant),
                quantity: Number(this.elements.quantity.value) || 1,
                selling_plan: this.sellingPlan,
                properties: {
                    ...this.customProperties,
                    '_itemReference': this.uniqueId + getRandomNumber()
                }
            }]
        });
        
        window.location.href = '/cart';
    };

    updatePrice = () => {
        // If there are no plans, update the regular price
        if(this.settings.plans === 0) {
            this.elements.productPrice.default.innerText = this.settings.prices[this.selectedSize.product].regular;
            return false;
        }

        this.elements.labels.regular.innerText = this.settings.prices[this.selectedSize.product].regular;
        this.elements.labels.subscription.innerText = this.settings.prices[this.selectedSize.product].subscription;
    };
    
    updateDescription = product => {

        const descriptionToDisplay = Array.from(this.elements.descriptions).find(description => description.dataset.nybTarget === product.trim());

        if (descriptionToDisplay) {
            this.elements.tab.innerHTML = descriptionToDisplay.innerHTML;
        }
        
        /* 
            Note: previous implememtation with custom description 
            if (this.elements.descriptions.length === 1) {
                return false;
            }
            this.elements.descriptions.forEach(description => {
                description.dataset.nybShow = description.dataset.nybTarget === product.trim();
            });
        */
    };

    checkUrlParams = () => {

        const params = GetUrlParams();

        if(!params.size) {
            return null;
        }

        if(params.size === '2dzn' || params.size === '3dzn') {
            // first child is the first size
            this.elements.sizeSelect[1].selected = true;
            this.elements.sizeSelect.dispatchEvent(new Event('change'));
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {

    const linkedProducts = document.querySelector('[data-nyb="LinkedProducts"]');

    if(!linkedProducts) {
        return false;
    }

    new LinkedProducts(linkedProducts, linkedProducts.dataset.nybSettings ? JSON.parse(linkedProducts.dataset.nybSettings) : {});
});

